import { DefaultFooter } from '@ant-design/pro-components';

const Footer: React.FC = () => {
  return (
    <DefaultFooter
      style={{
        background: 'none',
      }}
      copyright={`${new Date().getFullYear()} AimerPay - Serving merchants across Australia & New Zealand`}
      links={[
        {
          key: 'docs',
          title: 'Documentation',
          href: 'https://docs.adyen.com/platforms',
          blankTarget: true,
        },
        {
          key: 'support',
          title: 'Support',
          href: '/support',
          blankTarget: false,
        },
        {
          key: 'terms',
          title: 'Terms of Service',
          href: '/terms',
          blankTarget: false,
        },
        {
          key: 'privacy',
          title: 'Privacy Policy',
          href: '/privacy',
          blankTarget: false,
        },
      ]}
    />
  );
};

export default Footer;
